import { Box, Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCharge from "../../modal/modalCharge";
import MenuItem from '@mui/material/MenuItem';
import imageCompression from "browser-image-compression";
import {getApiBaseUrl} from '../../utils/getApiBaseUrl'; 
import { PostAmoxarifado, PostCategory, postCategory } from "../../services/amoxarifado.services";
import secureStorage from "../../utils/secureStorage";


const Categoriasamoxarifado = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [imageBase64, setImageBase64] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [tipo, setTipo] = useState("");
  const [descuento, setDescuento] = useState("");
  

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const USER = secureStorage.getItem('id');

    const { categoria } = values;

    const valuesToSend = {
        categoria: categoria.toUpperCase()
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await PostCategory(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const handleImageChange = async (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        const formData = new FormData();
        formData.append("image", compressedFile);

        const response = await fetch(`${getApiBaseUrl()}upload`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          setFieldValue("imagen", data.filePath);
          setImageBase64(data.filePath);
        } else {
          console.error("Error al subir la imagen");
        }
      } catch (error) {
        console.error("Error al comprimir la imagen:", error);
      }
    }
  };

  return (
    <Box m="20px">
      <Header title="Registro Categorias" subtitle="Registrar Categoria" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={() => setRegistrationError(false)}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
            categoria: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Categoria"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.categoria}
                name="categoria"
                error={!!touched.categoria && !!errors.categoria}
                helperText={touched.categoria && errors.categoria}
                sx={{ gridColumn: "span 4" }}
              />

            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
                <Button
                type="submit"
                variant="contained"
                sx={{
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#bac609" },
                    
                }}
                >
                Registrar
              </Button>
            </Box>
            <ModalCharge isLoading={isLoading} />
          </form>
        )}
      </Formik>
    </Box>
    );
};

const checkoutSchema = yup.object().shape({
    categoria: yup.string().required("La categoria es requerida"),
});

export default Categoriasamoxarifado;